(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const nav = document.querySelector('[data-fh-nav]');
    const progress = document.querySelector('[data-fh-progress]');
    const heroInner = document.querySelector('[data-fh-hero-inner]');
    const heroMedia = document.querySelector('[data-fh-hero-media]');

    const updateScrollEffects = () => {
      const top = window.scrollY || document.documentElement.scrollTop;
      const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);

      if (progress) progress.style.transform = `scaleX(${Math.min(1, top / max)})`;

      if (!reduceMotion && heroInner && heroMedia) {
        const hero = heroInner.closest('.fh-hero');
        const height = hero ? hero.offsetHeight : window.innerHeight;
        const amount = Math.min(1, top / Math.max(1, height));
        heroInner.style.transform = `translateY(${amount * 160}px)`;
        heroInner.style.opacity = String(Math.max(0, 1 - amount * 1.15));
        heroMedia.style.transform = `scale(${1.06 + amount * 0.12})`;
      }
    };

    updateScrollEffects();
    window.addEventListener('scroll', updateScrollEffects, { passive: true });

    const burger = nav?.querySelector('[data-fh-menu-toggle]');
    burger?.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
    });

    nav?.querySelectorAll('.fh-nav__links a').forEach((link) => {
      link.addEventListener('click', () => {
        nav.classList.remove('is-open');
        burger?.setAttribute('aria-expanded', 'false');
      });
    });

    document.querySelectorAll('[data-fh-scroll]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        const href = trigger.getAttribute('href');
        if (!href?.startsWith('#')) return;
        const target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });

    const revealItems = document.querySelectorAll('.fh-reveal');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver(
        (entries, instance) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            instance.unobserve(entry.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -30px' },
      );
      revealItems.forEach((item) => observer.observe(item));
    }

    document.querySelectorAll('[data-fh-filter-group]').forEach((group) => {
      const section = group.closest('.fh-shop');
      const cards = section?.querySelectorAll('[data-fh-product]') || [];
      const buttons = group.querySelectorAll('[data-filter]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const filter = button.dataset.filter || 'all';
          buttons.forEach((item) => item.classList.toggle('is-active', item === button));
          buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));

          cards.forEach((card) => {
            const searchable = card.dataset.searchable || '';
            const availability = card.dataset.availability || '';
            let matches = filter === 'all';
            if (filter === 'instock') matches = availability === 'instock';
            if (filter === 'next') matches = availability === 'next';
            if (!matches && filter !== 'all' && filter !== 'instock' && filter !== 'next') {
              const escapedFilter = filter.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
              matches = new RegExp(`(^|[^a-z0-9])${escapedFilter}([^a-z0-9]|$)`, 'i').test(searchable);
            }
            card.hidden = !matches;
          });
        });
      });
    });

    document.querySelectorAll('[data-fh-variant]').forEach((button) => {
      button.addEventListener('click', () => {
        const card = button.closest('[data-fh-product]');
        const input = card?.querySelector('input[name="id"]');
        if (!card || !input || button.disabled) return;
        card.querySelectorAll('[data-fh-variant]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        input.value = button.dataset.variantId;
      });
    });

    const initGiveawayGalleries = (root = document) => {
      root.querySelectorAll('[data-fh-giveaway-gallery]').forEach((gallery) => {
        if (gallery.dataset.fhGalleryReady === 'true') return;

        const mainImage = gallery.querySelector('[data-fh-gallery-main]');
        const counter = gallery.querySelector('[data-fh-gallery-counter]');
        const thumbnails = gallery.querySelectorAll('[data-fh-gallery-thumb]');
        if (!mainImage || thumbnails.length < 2) return;

        gallery.dataset.fhGalleryReady = 'true';
        thumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => {
            if (thumbnail.classList.contains('is-active')) return;

            mainImage.classList.add('is-changing');
            mainImage.src = thumbnail.dataset.imageSrc;
            mainImage.srcset = thumbnail.dataset.imageSrcset || '';
            mainImage.alt = thumbnail.dataset.imageAlt || '';

            thumbnails.forEach((item) => {
              const active = item === thumbnail;
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-pressed', String(active));
            });

            if (counter) counter.textContent = `${thumbnail.dataset.galleryIndex} / ${thumbnails.length}`;
            window.setTimeout(() => mainImage.classList.remove('is-changing'), reduceMotion ? 0 : 180);
          });
        });
      });
    };

    initGiveawayGalleries();
    document.addEventListener('shopify:section:load', (event) => initGiveawayGalleries(event.target));

    const normalizeCartLink = () => {
      const cart = document.querySelector('.fh-nav__cart#cart-icon-bubble');
      if (!cart) return;
      const bubbleValue = cart.querySelector('.cart-count-bubble [aria-hidden="true"]')?.textContent?.trim();
      const currentValue = cart.querySelector('.fh-nav__cart-count')?.textContent?.trim();
      const count = bubbleValue || currentValue || '0';
      if (!cart.querySelector('.fh-nav__cart-label')) {
        cart.innerHTML = `<span class="fh-nav__cart-label">Cart</span> <span class="fh-nav__cart-count">${count}</span>`;
      }
    };

    normalizeCartLink();
    const cartLink = document.querySelector('.fh-nav__cart#cart-icon-bubble');
    if (cartLink && 'MutationObserver' in window) {
      new MutationObserver(normalizeCartLink).observe(cartLink, { childList: true, subtree: true });
    }
  });
})();
